module.exports = __webpack_public_path__ + "d664201f/img/pwrd-by-sourcery-black.bba9ba41.svg";